import { initStorageService } from '~/services'

export default async (context) => {
  initStorageService(context)
}
